import Swiper, { Navigation } from 'swiper';

export default function initTeam() {
  const team = document.querySelectorAll('.team');
  if (!team) return;

  team.forEach((el) => {
    const slider = el.querySelector('.swiper');
    const arrowNext = el.querySelector('.swiper-button-next');
    const arrowPrev = el.querySelector('.swiper-button-prev');

    const swiper = new Swiper(slider, {
      modules: [Navigation],
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: {
        nextEl: arrowNext,
        prevEl: arrowPrev
      }
    });
    swiper.init();
  });
}
